import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';
import { BorrowerState } from 'app/store/borrower/borrower/borrower.state';
import { Observable, Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MessageThreadsDialogComponent } from '../message-threads-dialog/message-threads-dialog.component';

@Component({
  selector: 'app-email-button-menu',
  templateUrl: './email-button-menu.component.html',
  styleUrls: ['./email-button-menu.component.scss'],
  standalone: false
})
export class EmailButtonMenuComponent implements OnInit, OnDestroy {
  @Select(BorrowerState.borrower) borrower$: Observable<Borrower>;

  @Input() borrowerId: number;
  borrower: null | Borrower;
  disabled: boolean = false;
  showDropDown: boolean = false;

  destroyed$ = new Subject<boolean>();

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.borrower$.subscribe(borrower => {
      this.borrower = borrower;
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  handleClick() {
    this.dialog.open(MessageThreadsDialogComponent, {
      width: '40vw',
      height: '80vh',
      autoFocus: true,
      data: {
        borrower: this.borrower,
      },
      panelClass: 'message-dialog-panel'
    });
  }

}
